import { boolean, constraints, mixedObj, object, slider } from "./helpers";
import { DeviceSettingOptions } from "./settingOptions";
import { Audio } from "./types";

export const audio = object<Audio>({
  auto_pause_music: object({
    value: boolean("AUTO_PAUSE_MUSIC"),
    constraints: constraints()
  }),
  volume_alerts: object({
    value: mixedObj(DeviceSettingOptions.volumeAlertsOpts, "VOLUME_ALERTS")
  }),
  noise_exposure_limit: object({
    value: mixedObj(
      DeviceSettingOptions.noiseExposureLimitOpts,
      "NOISE_EXPOSURE_LIMIT"
    )
  }),
  hours_on_phone_per_day: object({
    value: mixedObj(
      DeviceSettingOptions.hoursOnPhoneDayOpts,
      "HOURS_ON_PHONE_DAY"
    )
  }),
  anti_startle: object({
    value: boolean("ANTI_STARTLE"),
    constraints: constraints()
  }),
  g616: object({ value: boolean("G616"), constraints: constraints() }),
  volume_level_indicators: object({
    value: mixedObj(
      DeviceSettingOptions.volumeLevelIndicatorsOpts,
      "VOLUME_LEVEL_TONES"
    )
  }),
  audio_quality: object({
    value: mixedObj(DeviceSettingOptions.audioQualityOpts, "AUDIO_QUALITY")
  }),
  streaming_audio: object({
    value: boolean("STREAMING_AUDIO"),
    constraints: constraints()
  }),
  extended_range: object({
    value: boolean("EXTENDED_RANGE"),
    constraints: constraints()
  }),
  tone_control: object({
    value: mixedObj(DeviceSettingOptions.toneControlOpts, "TONE_CONTROL")
  }),
  anc_timeout: object({
    value: mixedObj(DeviceSettingOptions.ancTimeoutOpts, "ANC_TIMEOUT")
  }),
  independent_volume_control: object({
    value: boolean("INDEPENDENT_VOLUME_CONTROL"),
    constraints: constraints()
  }),
  acoustic_fence: object({
    value: mixedObj(
      DeviceSettingOptions.acousticFenceOpts,
      "POLY_ACOUSTIC_FENCE"
    )
  }),
  noise_block_ai: object({
    value: boolean("NOISE_BLOCK_AI"),
    constraints: constraints()
  }),
  stereo: object({
    value: boolean("STEREO_AUDIO"),
    constraints: constraints()
  }),
  bass: object({ value: slider("AUDIO_BASS"), constraints: constraints() }),
  treble: object({ value: slider("AUDIO_TREBLE"), constraints: constraints() })
}).required();
